import axios from 'axios'
import {
    getUserRefreshToken,
    removeUserRefreshToken,
    removeUserToken,
    setUserRefreshToken
} from "../localStorage/LocalStorageService";
import {RouteInfo} from "../../route/RouteHelper";
import {LoginService} from "../../pages/login/LoginService";
import {CashService} from "../../pages/CashInfo/CashService";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";

export class HttpClient {

    //todo : change base url ...
    constructor(config = {},
                baseUrl = "https://api.sandooghmn.ir/"
                // baseUrl = "http://localhost:8080/"

    ) {
        this.clientId = "raiko-manager-fund-web"
        this.clientSecret = "96dff009-4161-48aa-a258-55ec846810ad"
        // this.clientSecret = "3rovp4Gl8ZE4FeWlNRgHnK5hsNGMKNHm"
        this.realName = "raiko-manager-fund-web"
        this.contentTypeJson = "application/json"

        this.instance = axios.create({
                ...config,
                baseURL: baseUrl
            }
        )

        this.instance.interceptors.response.use((response) => response, (error) => {
            //error.response.status === 403


            throw error;
        })
    }

    logoutManager() {
        removeUserToken()
        removeUserRefreshToken()
        window.location.href = RouteInfo.Login
    }

    post(url, data = {}, header = {}, params = {}) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'post',
                url: url,
                params: params,
                headers: header,
                data: data,
            }).then(response => resolve(response.data))
                .catch(error => {
                    reject(error)
                })
        })
    }

    get(
        url, header = {}, params = {}, data = {}, cancelToken) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'get',
                url: url,
                params: params,
                data: data,
                headers: header,
                ...cancelToken
            }).then(response => resolve(response.data))
                .catch(error => {
                    reject(error)
                })
        })
    }

    getFile(
        url, header = {}, params = {}, data = {}) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'get',
                url: url,
                data: data,
                params: params,
                headers: header,
                responseType: "blob"
            }).then(response => resolve(response.data))
                .catch(error => {
                    reject(error)
                })
        })
    }

    getData(
        url, data = {}) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'get',
                url: url,
                data: data,
            }).then(response => resolve(response.data))
                .catch(error => {
                    reject(error)
                })
        })
    }


    put(url, header = {}, data = {}, params = {}) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'put',
                url: url,
                params: params,
                headers: header,
                data: data
            }).then(response => resolve(response.data))
                .catch(error => {
                    reject(error)
                })
        })
    }

    delete(url, header = {}, data = {}, params = {}) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'delete',
                url: url,
                params: params,
                headers: header,
                data: data
            }).then(response => resolve(response.data))
                .catch(error => {
                    reject(error)
                })
        })
    }

    convertToken(token) {
        let _token = ""
        _token = "bearer " + token
        return _token
    }

    prepareUserAccessHeader(token) {
        return {
            "Authorization": this.convertToken(token),
            "REALM-NAME": this.realName
        }
    }

    getClientId() {
        return this.clientId
    }

    getClientSecret() {
        return this.clientSecret
    }

}